module.exports = __webpack_public_path__ + "./Joan2_2c15ac627477eccd04f5b7b7bb33bf78.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Joan2.png
// module id = 565
// module chunks = 0